import React, { useEffect, useRef, useState } from "react";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import StopIcon from "@material-ui/icons/Stop";
import { Button } from "@material-ui/core";
import { getLocalizedString, language } from "@icarius-localization/strings";

const TextToSpeech = ({ text }) => {

    const [isPlaying, setIsPlaying] = useState(false);

    const cancelledRef = useRef(false);
    const chunkIndexToPlayRef = useRef(0);

    useEffect(() => {
        return () => window.speechSynthesis.cancel();
    }, []);

    const getChunks = (text) => text.match(/[^.!?]+[.!?]+/g) || [text]; // si es muy largo el texto chrome no lo reproduce

    const playNextChunk = (chunks) => {
        if (cancelledRef.current || chunkIndexToPlayRef.current >= chunks.length) {
            setIsPlaying(false);
            return;
        }

        const utterance = new SpeechSynthesisUtterance(chunks[chunkIndexToPlayRef.current]);
        utterance.lang = language;

        utterance.onend = () => {
            if (cancelledRef.current) return;
            chunkIndexToPlayRef.current += 1;
            playNextChunk(chunks);
        };

        utterance.onerror = () => setIsPlaying(false);

        window.speechSynthesis.speak(utterance);
    };

    const speak = () => {
        window.speechSynthesis.cancel();

        cancelledRef.current = false;
        chunkIndexToPlayRef.current = 0;

        const chunks = getChunks(text);
        setIsPlaying(true);
        playNextChunk(chunks);
    };

    const stop = () => {
        cancelledRef.current = true;
        window.speechSynthesis.cancel();
        setIsPlaying(false);
    };

    if (!window.speechSynthesis || !text) return null;

    return (
        <Button
            onClick={isPlaying ? stop : speak}
            variant="contained"
            className="whiteText"
            style={{ fontSize: 12, minWidth: 135 }}
            startIcon={isPlaying ? <StopIcon /> : <PlayArrowIcon />}
        >

            {getLocalizedString(isPlaying ? "stop" : "play")}
        </Button>
    );
}

export default TextToSpeech;